export default __webpack_public_path__ + "static/media/1.9ef2eb7c.jpg";